import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
// components
import TrainerList from './TrainerList/TrainerList';
import TrainerTable from './TrainerList/TrainerTable';
import ManageTrainer from './ManageTrainer/ManageTrainer';
// css
import './Trainer.scss';

class Trainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			toggleView: true,
			trainerModal: false,
			title: '',
			trainerId: '',
			trainerDetails: {
				firstname: '',
				lastname: '',
				email: '',
				phone: '',
				country: '',
				city: ''
			},
			errorTrainerDetails: {
				firstname: true,
				lastname: true,
				email: true
			}
		}
		this.manageTrainer = this.manageTrainer.bind(this);
		this.confirmTrainerAction = this.confirmTrainerAction.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		const { } = this.state;
		const { trainerContext } = this.props;

		trainerContext.getTrainerList(1,25);
	}

	componentWillUnMount() {
		this.props.trainerContext.clearTrainerList();
		this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { trainerDetails: { firstname, lastname, email, phone, country, city } } = nextProps.trainerContext;

		if (title === 'edit') {
			this.setState({
				trainerDetails: { firstname, lastname, email, phone, country, city },
				errorTrainerDetails: {
					firstname: !firstname || firstname === '',
					lastname: !lastname || lastname === '',
					email: !email || email === ''
				}
			});
		}
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.trainerContext.getTrainerList(curr_page, size);
	}

	// Modal (trainer_module)

	// open Modal (trainer_module)
	manageTrainer = (value, title = null, trainer_id = null) => {
		const { getTrainerDetails } = this.props.trainerContext;
		if (value) {
			if (title === 'edit') {
				getTrainerDetails(trainer_id);
			} else {
				this.setState({
					trainerDetails: {
						firstname: '',
						lastname: '',
						email: '',
						phone: '',
						country: '',
						city: ''
					},
					errorTrainerDetails: {
						firstname: true,
						lastname: true,
						email: true
					}
				});
			}
		} else {
			this.setState({
				trainerDetails: {
					firstname: '', 
					lastname: '',
					email: '',
					phone: '',
					country: '',
					city: ''
				},
				errorTrainerDetails: {
					firstname: true,
					lastname: true,
					email: true
				}
			});
		}
		this.setState({
			trainerId: trainer_id,
			trainerModal: value,
			title
		});
	}

	// modal onchange fields (trainer_module)
	onChange = (e, val) => {
		this.setState({
			trainerDetails: {
				...this.state.trainerDetails,
				[e.target.name]: e.target.value
			},
			errorTrainerDetails: {
				...this.state.errorTrainerDetails,
				[e.target.name]: val
			}
		});
	}

	confirmTrainerAction = () => {
		const { title, trainerDetails, trainerId } = this.state;
		const { updateTrainerDetails, deleteTrainer, addTrainer } = this.props.trainerContext;

		if (title === 'edit') {
			updateTrainerDetails(trainerDetails, trainerId);
		} else if (title === 'add') {
			addTrainer(trainerDetails);
		} else if (title === 'delete') {
			deleteTrainer(trainerId);
		}
	}

	onToggle = () => {
		this.setState({
			...this.state,
			toggleView: !this.state.toggleView
		});
	}

	onDisable = (ers) => {
		const value = Object.keys(ers).some(val => ers[val] === true);
		return value;
	}


	render() {
		const { trainerList } = this.props.trainerContext;
		const { pagination } = this.props.commonContext;
		const { trainerModal, title, trainerDetails } = this.state;

		return (
			<div className='Trainer'>
				<PageHeader
					title='Trainer List'
					btnText='Trainer'
					onAdd={() => this.manageTrainer(true, 'add')}
					isToggle
					toggleValue={this.state.toggleView}
					onToggle={() => this.onToggle()}
				/>
				{this.state.toggleView ? (
					<TrainerTable
						trainerList={trainerList}
						manageTrainer={this.manageTrainer}
					/>
				) : (
						<TrainerList
							trainerList={trainerList}
							manageTrainer={this.manageTrainer}
						/>
					)}
				{pagination && pagination.totalElements > 0 &&
                    <Pagination
                        totalPage={pagination.totalPages}
                        onChangePage={this.onChangePage}
                        count={pagination.totalElements}
                        first={pagination.first}
                        last={pagination.last}
                    />
                }
				{/* Add, Edit, and delete trainer */}
				{trainerModal &&
					<Modal
						modalOpen={trainerModal}
						toggleModal={this.manageTrainer}
						title={`${title} Trainer`}
						disabled={title !== 'delete' && this.onDisable(this.state.errorTrainerDetails)}
						confirm={this.confirmTrainerAction}
					>
						<ManageTrainer
							isEdit={title === 'edit'}
							onDelete={title === 'delete'}
							trainerDetails={trainerDetails}
							onChange={(e, val) => this.onChange(e, val)}
						/>
					</Modal>
				}
				{/* Add, Edit, and delete trainer */}
			</div>
		);
	}
}


Trainer.propTypes = {
	value: PropTypes.instanceOf(Object)
};

Trainer.defaultProps = {
	value: {}
};

export default Trainer;



// WEBPACK FOOTER //
// ./components/Trainer/Trainer.js